export const arNotificationsTranslations = {
	notifications: {
		'auth/login/fulfilled': 'تم تسجيل الدخول بنجاح',
		'auth/register/fulfilled': 'تم إنشاء الحساب بنجاح',
		'organization/createUserOrganization/fulfilled': 'تم إنشاء المؤسسة بنجاح',
		'organization/updateUserOrganization/fulfilled': 'تم تحديث المؤسسة بنجاح',
		'branch/createNewBranch/fulfilled': 'تم إنشاء الفرع بنجاح',
		'branch/updateBranchData/fulfilled': 'تم تحديث الفرع بنجاح',
		'branch/deleteBranchData/fulfilled': 'تم حذف الفرع بنجاح',
		'category/createNewCategory/fulfilled': 'تم إنشاء الفئة بنجاح',
		'category/updateCategoryData/fulfilled': 'تم تحديث الفئة بنجاح',
		'category/deleteCategoryData/fulfilled': 'تم حذف الفئة بنجاح',
		'menuItem/createNewMenuItem/fulfilled': 'تم إنشاء عنصر القائمة بنجاح',
		'menuItem/updateMenuItemData/fulfilled': 'تم تحديث عنصر القائمة بنجاح',
		'menuItem/deleteMenuItemData/fulfilled': 'تم حذف عنصر القائمة بنجاح',
		'branch/publishBranch/fulfilled': 'تم نشر القائمة بنجاح',
		unexpectedError: 'حدث خطأ غير متوقع'
	}
};